import { clsx } from "clsx";
/**
 * Utility for merging class names with Tailwind CSS support.
 * Uses clsx for conditional classes.
 */
export function cn(...inputs) {
    return clsx(inputs);
}
//# sourceMappingURL=cn.js.map